<app-custom-breadcrumb [crumbs]="breadcrumbs" xmlns="http://www.w3.org/1999/html"></app-custom-breadcrumb>
<div class="flex items-center gap-3 my-3">
  <app-back-option-section [loading]="loading"></app-back-option-section>
  <h2>{{reservationId ? 'Edit Other Booking' : 'Add New Other Booking'}}</h2>
</div>

<!--form section-->
<section [ngClass]="!loading ? 'block' : 'hidden'">
  <nz-card>

    <div>
      <h5 class="text-primary">Booking Details</h5>
      <div>
        <form nz-form [formGroup]="otherBookingForm" [nzLayout]="'vertical'">
          <div class="grid xl:grid-cols-2 gap-2" formGroupName="reservationDetails">
            <nz-form-item class="grid grid-flow-row content-start">
              <nz-form-label nzFor="reason" nzRequired>Reason</nz-form-label>
              <nz-form-control [nzErrorTip]="reasonError">
                <input nz-input type="text" [min]="0" formControlName="reason" placeholder="Enter Reason"/>
              </nz-form-control>
              <ng-template #reasonError>
                <span *ngIf="formErrors.reservationDetails.reason.required">Please enter name. </span>
                <span *ngIf="formErrors.reservationDetails.reason.maxlength">Maximum 70 letters only. </span>
                <span *ngIf="formErrors.reservationDetails.reason.pattern">Only allowed letters, please avoid adding special characters or numbers. </span>
              </ng-template>
            </nz-form-item>
          </div>
          <div class="grid sm:grid-cols-2 xl:grid-cols-4 gap-2" formGroupName="reservationDetails">
            <nz-form-item class="grid grid-flow-row content-start">
              <nz-form-label nzFor="arrivalDate" nzRequired>Start Date</nz-form-label>
              <nz-form-control [nzErrorTip]="arrivalDateError">
                <nz-date-picker class="w-full" formControlName="arrivalDate"
                                nzPlaceHolder="Select Date" [nzDisabledDate]="disabledDate"></nz-date-picker>
              </nz-form-control>
              <ng-template #arrivalDateError>
                <span *ngIf="formErrors?.reservationDetails.arrivalDate?.required">Please select date. </span>
              </ng-template>
            </nz-form-item>
            <nz-form-item class="grid grid-flow-row content-start">
              <nz-form-label nzFor="arrivalTime" nzRequired>Start Time</nz-form-label>
              <nz-form-control [nzErrorTip]="arrivalTimeError">
                <nz-time-picker class="w-full" formControlName="arrivalTime" nzPlaceHolder="Select Time"  [nzFormat]="'HH:mm'"></nz-time-picker>
              </nz-form-control>
              <ng-template #arrivalTimeError>
                <span *ngIf="formErrors?.reservationDetails.arrivalTime?.required">Please select time. </span>
              </ng-template>
            </nz-form-item>
            <nz-form-item class="grid grid-flow-row content-start">
              <nz-form-label nzFor="departureDate" nzRequired>End Date</nz-form-label>
              <nz-form-control [nzErrorTip]="departureDateError">
                <nz-date-picker class="w-full" formControlName="departureDate" [nzDisabledDate]="disabledDate"
                                nzPlaceHolder="Select Date"></nz-date-picker>
              </nz-form-control>
              <ng-template #departureDateError>
                <span *ngIf="formErrors?.reservationDetails.departureDate?.required">Please select date. </span>
              </ng-template>
            </nz-form-item>
            <nz-form-item class="grid grid-flow-row content-start">
              <nz-form-label nzFor="departureTime" nzRequired>End Time</nz-form-label>
              <nz-form-control [nzErrorTip]="departureTimeError">
                <nz-time-picker class="w-full" formControlName="departureTime" nzPlaceHolder="Select Time"  [nzFormat]="'HH:mm'"></nz-time-picker>
              </nz-form-control>
              <ng-template #departureTimeError>
                <span *ngIf="formErrors?.reservationDetails.departureTime?.required">Please select time. </span>
              </ng-template>
            </nz-form-item>
            <nz-form-item class="grid grid-flow-row content-start">
              <nz-form-label nzFor="noOfDays" nzRequired>No. of Days</nz-form-label>
              <nz-form-control [nzErrorTip]="noOfDaysError">
                <input nz-input type="number" formControlName="noOfDays" placeholder="Enter Number"/>
              </nz-form-control>
              <ng-template #noOfDaysError>
                <span *ngIf="formErrors.reservationDetails.noOfDays.required">Please enter name. </span>
                <span *ngIf="formErrors.reservationDetails.noOfDays.maxlength">Maximum 70 letters only. </span>
                <span *ngIf="formErrors.reservationDetails.noOfDays.pattern">Only allowed letters, please avoid adding special characters or numbers. </span>
              </ng-template>
            </nz-form-item>
          </div>

        </form>
      </div>
    </div>

    <div>
      <h5 class="text-primary">Allocation Details </h5>
      <div>
        <form nz-form [formGroup]="otherBookingForm" [nzLayout]="'vertical'">
          <div class="grid xl:grid-cols-2 gap-2" formGroupName="allocationDetails">
           <div>
             <h6 class="my-2">Vehicle Allocation</h6>
             <div class="flex items-center gap-3 my-4">
              <button (click)="refreshVehicles()" class="px-[5px]" nz-button nzType="primary"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-rotate-cw"><path d="M21 12a9 9 0 1 1-9-9c2.52 0 4.93 1 6.74 2.74L21 8"/><path d="M21 3v5h-5"/></svg>
              </button>
              <h6 class="font-normal">Refresh before you allocate the vehicle</h6>
             </div>
             <div class="grid sm:grid-cols-2 gap-4">
               <nz-form-item class="grid grid-flow-row content-start">
                 <nz-form-label nzFor="vehicleCategory" nzRequired>Vehicle Category</nz-form-label>
                 <nz-form-control [nzErrorTip]="vehicleCategoryError">
                   <nz-select class="w-full" formControlName="vehicleCategory" nzPlaceHolder="Select Preference">
                     <nz-option *ngFor="let category of vehicleCat" [nzValue]="category._id" [nzLabel]="category.name"></nz-option>
                   </nz-select>
                 </nz-form-control>
                 <ng-template #vehicleCategoryError>
                   <span *ngIf="formErrors?.allocationDetails.vehicleCategory?.required">Please select type. </span>
                 </ng-template>
               </nz-form-item>

               <nz-form-item class="grid grid-flow-row content-start">
                 <nz-form-label nzFor="allocatedVehicle" nzRequired>Allocated Vehicle </nz-form-label>
                 <nz-form-control [nzErrorTip]="allocatedVehicleError">
                   <nz-select class="w-full" nzAllowClear nzShowSearch  (ngModelChange)="getFleetVehicle($event)" (nzOnSearch)="onSearchAllocatedVehicle($event)"  formControlName="allocatedVehicle"  nzPlaceHolder="Select Preference">
                     <nz-option  *ngFor="let vehicle of this.filteredAvailableVehicles" [nzValue]="vehicle._id" [nzLabel]="vehicle.vehicleName" [nzDisabled]="disableSelectedVehicle(vehicle._id)"></nz-option>
<!--                     <nz-option nzCustomContent *ngFor="let vehicle of this.filteredAvailableVehicles" [nzValue]="vehicle._id" [nzLabel]="vehicle.vehicleName">-->
<!--                       <div class="flex items-center fleet-availability-status">-->
<!--                         <div [nz-tooltip]="getVehicleAvailabilityIcon(vehicle.availabilityStatus)?.label" class="vehicle-status-mark {{getVehicleAvailabilityIcon(vehicle.availabilityStatus)?.bgColor}}"></div>-->
<!--                         <div>{{vehicle.vehicleName}}</div>-->
<!--                       </div>-->
<!--                     </nz-option>-->
                   </nz-select>
                 </nz-form-control>
                 <ng-template #allocatedVehicleError>
                   <span *ngIf="formErrors?.allocationDetails.allocatedVehicle?.required">Please select type. </span>
                 </ng-template>
                 <p class="my-2 text-primary text-sm" *ngIf="fleetsFetching">Loading...</p>
               </nz-form-item>
             </div>
             <div class="grid sm:grid-cols-2 gap-2">

             </div>
           </div>
            <div>
              <span nz-checkbox formControlName="driverAllocationCheck" class="mb-4">Driver Allocation</span>
              <div *ngIf="otherBookingForm.get('allocationDetails').get('driverAllocationCheck').value">
                <div>
                  <nz-form-item class="grid grid-flow-row content-start">
                    <nz-form-label nzFor="driverCategory" nzRequired>Driver Category</nz-form-label>
                    <nz-form-control [nzErrorTip]="driverCategoryError">
                      <nz-select class="w-full" formControlName="driverCategory" (ngModelChange)="getDriverOptions($event)" nzPlaceHolder="Select Preference">
                        <nz-option nzValue="SR_DRIVER" nzLabel="SR Drivers"></nz-option>
                        <nz-option nzValue="OUTSOURCE_DRIVER" nzLabel="Outsourced Drivers"></nz-option>
                      </nz-select>
                    </nz-form-control>
                    <ng-template #driverCategoryError>
                      <span *ngIf="formErrors?.allocationDetails.driverCategory?.required">Please select type. </span>
                    </ng-template>
                  </nz-form-item>
                </div>
                <div >
                  <div class="flex items-center gap-3 my-4">
                    <button (click)="refreshDrivers()" class="px-[5px]" nz-button nzType="primary"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-rotate-cw"><path d="M21 12a9 9 0 1 1-9-9c2.52 0 4.93 1 6.74 2.74L21 8"/><path d="M21 3v5h-5"/></svg>
                    </button>
                    <h6 class="font-normal">Refresh before you allocate the driver</h6>
                   </div>
                  <div class="grid sm:grid-cols-2 gap-2 mb-6">
                    <nz-form-item class="grid grid-flow-row content-start mb-0">
                      <nz-form-label nzFor="allocatedDriver" nzRequired>Allocated Driver</nz-form-label>
                      <nz-form-control [nzErrorTip]="allocatedDriverError">
                        <nz-select class="w-full" nzAllowClear nzShowSearch (nzOnSearch)="onSearchDriver($event)" formControlName="allocatedDriver" (ngModelChange)="getSupplierVehicles($event);getDriver($event)" nzPlaceHolder="Select Preference">
  <!--                        <nz-option *ngFor="let op of filteredAvailableDriver" nzValue="{{op._id}}"-->
  <!--                                   nzLabel="{{op.fullName}}"></nz-option>-->
                          <nz-option nzCustomContent *ngFor="let op of filteredAvailableDriver" nzValue="{{op._id}}" [nzLabel]="op.fullName">
                            <div class="flex items-center driver-availability-status">
                              <div [nz-tooltip]="getDriverAvailabilityIcon(op.driverAvailability)?.label" class="vehicle-status-mark {{getDriverAvailabilityIcon(op.driverAvailability)?.bgColor}}"></div>
                              <div>{{op.fullName}}</div>
                            </div>
                          </nz-option>
                        </nz-select>
                      </nz-form-control>
                      <ng-template #allocatedDriverError>
                        <span *ngIf="formErrors?.allocationDetails.allocatedDriver?.required">Please select type. </span>
                      </ng-template>
                      <p class="my-2 text-primary text-sm" *ngIf="driversFetching">Loading...</p>
                    </nz-form-item>
                    <div class="flex items-end">
                      <button class="outline-button" nz-button nzType="default" (keydown.enter)="$event.preventDefault()" (click)="showAddDriverPopup()" nz-popconfirm>Add New Driver</button>
                    </div>
                  </div>
                </div>
                <div *ngIf="otherBookingForm.get('allocationDetails').get('driverCategory').value === 'OUTSOURCE_DRIVER'" class="grid sm:grid-cols-2 gap-2 mb-6">
                  <nz-form-item class="grid grid-flow-row content-start mb-0">
                    <nz-form-label nzFor="allocatedDriverVehicle" nzRequired>Allocated Vehicle</nz-form-label>
                    <nz-form-control [nzErrorTip]="allocatedDriverVehicleError">
                      <nz-select class="w-full" nzAllowClear nzShowSearch (ngModelChange)="getSupplierVehicle($event)"  (nzOnSearch)="onSearchSupplierVehicle($event)" formControlName="allocatedDriverVehicle" nzPlaceHolder="Select Preference">
                        <nz-option *ngFor="let op of supplierVehicleOptions" nzValue="{{op?._id}}"
                                   nzLabel="{{op?.registerNumber}} | {{op?.vehicleModel}}" [nzDisabled]="disableSelectedOutSourceVehicle(op._id)"></nz-option>
                      </nz-select>
                    </nz-form-control>
                    <ng-template #allocatedDriverVehicleError>
                      <span *ngIf="formErrors?.allocationDetails.allocatedDriverVehicle?.required">Please select type. </span>
                    </ng-template>
                    <p class="my-2 text-primary text-sm" *ngIf="supplierVehiclesFetching">Loading...</p>
                  </nz-form-item>
                  <div class="flex items-end">
                    <button class="outline-button" nz-button nzType="default" (keydown.enter)="$event.preventDefault()"  [disabled]="this.otherBookingForm.get('allocationDetails.allocatedDriver').value === null" (click)="showAddVehiclePopup()" nz-popconfirm>Add New Vehicle</button>
                  </div>
                </div>

                <div *ngIf="otherBookingForm.get('allocationDetails').get('driverCategory').value === 'OUTSOURCE_DRIVER'" class="grid sm:grid-cols-2 gap-2 mb-6"><nz-form-item class="grid grid-flow-row content-start mb-0">
                  <nz-form-label nzFor="outsourcedRate" nzRequired>Outsourced Rate</nz-form-label>
                  <nz-form-control [nzErrorTip]="allocatedDriverVehicleError">
                    <nz-input-number-group [nzAddOnAfter]="addOnAfterTemplate">
                      <nz-input-number formControlName="outsourcedRate" [nzPlaceHolder]="'Enter rate'" [nzStep]="1" [nzMin]="0"></nz-input-number>
                    </nz-input-number-group>
                    <ng-template #addOnAfterTemplate>
                      <div style="display: flex; align-items: center;">
                        <span ></span>
                        <nz-select formControlName="outsourcedRateCurrency" style="width: 80px;">
                          <nz-option *ngFor="let op of currencyOptions" [nzValue]="op._id" [nzLabel]="op.currencyCode"></nz-option>
                        </nz-select>
                      </div>
                    </ng-template>
                  </nz-form-control>
                  <ng-template #allocatedDriverVehicleError>
                    <span *ngIf="formErrors?.allocationDetails.outsourcedRate?.required">Please select type. </span>
                  </ng-template>
                </nz-form-item>

                </div>
              </div>
            </div>
         </div>
        </form>
      </div>
    </div>
<div class="grid sm:grid-cols-1 md:grid-cols-2 xl:grid-cols-2 gap-3 mt-6">
    <div class="grid sm:grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-3" style="min-height: 200px">

      <div *ngIf="otherBookingForm.get('allocationDetails').get('driverCategory').value !== 'OUTSOURCE_DRIVER'">
        <div class="sub-section" style="height: 100%">
          <img width="90%" [src]="this.vehicle.image" alt="image">
        </div>
      </div>

      <div *ngIf="otherBookingForm.get('allocationDetails.driverCategory').value !== 'OUTSOURCE_DRIVER'">
        <div style="height: 100%">
          <div class="mb-5 mt-5">
            <p class="subject-name">Registration Number</p>
            <p class="subject-data">{{this.vehicle.registrationNo}}</p>
          </div>

        </div>
      </div>

      <div *ngIf="otherBookingForm.get('allocationDetails.driverCategory').value !== 'OUTSOURCE_DRIVER'">
        <div style="height: 100%">
          <div class="mb-5 mt-5">
            <p class="subject-name">No. Of Seats</p>
            <p class="subject-data">{{this.vehicle.seats}}</p>
          </div>
        </div>
      </div>

    </div>


    <div class="grid sm:grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-3">

      <div>
        <div class="sub-section" style="height: 100%">
          <div class="item-row mb-5">
            <p class="subject-name">Driver Name: </p>
            <p class="subject-data">{{driver.name}}</p>
          </div>
          <div class="item-row mb-5">
            <p class="subject-name">Mobile Number: </p>
            <p class="subject-data">{{driver.mobileNo}}</p>
          </div>
          <div class="item-row mb-5" *ngIf="driver.supplier !== '-'">
            <p class="subject-name">Supplier: </p>
            <p class="subject-data">{{driver.supplier}}</p>
          </div>
        </div>
      </div>


    </div>
</div>

    <div class="flex justify-end mt-10">
      <button class="outline-button mr-3" nz-button nzType="default" nz-popconfirm
              nzPopconfirmTitle="Are you sure you want to cancel this fleet? You will lost all data."
              [nzOkText]="'Yes'" [nzCancelText]="'No'" (nzOnConfirm)="bookingCancel()"
      >Cancel
      </button>
      <button nz-button nzType="primary" nz-popconfirm
              nzPopconfirmTitle="{{reservationId ? 'Are you sure you want to save this information' : 'Are you sure you want to add new Booking?'}}"
              [nzOkText]="'Yes'" [nzCancelText]="'No'" [disabled]="otherBookingForm.invalid"
              (nzOnConfirm)="submit()">Update Booking</button>
    </div>
    <nz-alert *ngIf="actionMessage.display" class="mt-2" [nzType]="actionMessage.type"
              [nzMessage]="actionMessage.message" nzShowIcon></nz-alert>

  </nz-card>
</section>
<div [ngClass]="loading ? 'block' : 'hidden'">
  <app-edit-view-skeleton-template></app-edit-view-skeleton-template>
</div>

<app-add-driver-popup [isVisible]="visibleAddDriverPopup"
                      (addEditDriverOnChange)="onGetAddDriverChange($event)"></app-add-driver-popup>
<app-vehicle-details-form [isVisible]="visibleAddVehiclePopup"
                      (addVehicleOnChange)="onGetAddVehicleChange($event)" [supplier]="this.supplierId"></app-vehicle-details-form>
